import { mpaasHttp, httpDataStatus } from "../../utils/MpaasHttpClient";
import UrlConstants from "../../utils/UrlConstants";
import { mpaasHttpAction } from "../../utils/MpaasHttpActionHandler";

export const FetchCiConfig = (data: Object) => {
    return new Promise((resolve, reject) => {
        mpaasHttp.get(UrlConstants.CI_CONFIG, data).then((response: any) => {
            if (response.status === httpDataStatus.SUCCESS) {
                resolve(response);
            } else {
                const err = response
                mpaasHttpAction.error(mpaasHttpAction.makeErrorData(err?.error?.message, {...err, showAlert: true}));
                reject(response);
            }
        })
            .catch((err) => {
                mpaasHttpAction.error(mpaasHttpAction.makeErrorData(err?.error?.message, {...err, showAlert: true}));
                reject(err)
            });
    });
};

export const UpdateCiConfig = (data: any) => {
    return new Promise((resolve, reject) => {
        mpaasHttp.post(UrlConstants.CI_CONFIG, data).then((response: any) => {
            if (response.status === httpDataStatus.SUCCESS) {
                resolve(response);
            } else {
                const err = response
                mpaasHttpAction.error(mpaasHttpAction.makeErrorData(err?.error?.message, {...err, showAlert: true}));
                reject(response);
            }
        })
            .catch((err) => {
                mpaasHttpAction.error(mpaasHttpAction.makeErrorData(err?.error?.message, { ...err, showAlert: true }));
                reject(err)

            });
    });
};

export const UpdateCiStatus = (data: any) => {
    return new Promise((resolve, reject) => {
        mpaasHttp.post(UrlConstants.CI_STATUS, data).then((response: any) => {
            if (response.status === httpDataStatus.SUCCESS) {
                resolve(response);
            } else {
                const err = response
                mpaasHttpAction.error(mpaasHttpAction.makeErrorData(err?.error?.message, {...err, showAlert: true}));
                reject(response);
            }
        })
            .catch((err) => {
                mpaasHttpAction.error(mpaasHttpAction.makeErrorData(err?.error?.message, {...err, showAlert: true}));
                reject(err)
            });
    });
};